import React, { useState, useEffect } from 'react';
import { get_dlqi_plqi } from "../Services/Service";

function Psqi({ uuid }) {
    const [psqiResponse, setPsqiResponse] = useState([]);

    useEffect(() => {
        const fetchPsqi = async () => {
            try {
                const psqiResponse = await get_dlqi_plqi({ uuid: uuid, type: "psqi" });
                console.log(psqiResponse);
                setPsqiResponse(psqiResponse.data.data);
            } catch (error) {
                console.error(error);
            }
        };

        fetchPsqi();
    }, [uuid]); // Run effect whenever `uuid` changes

    return (
        <div className='row'>
            {psqiResponse && psqiResponse.map(psqiVal => (
                <>
                    <div className='col-md-4 mt-4 border-start px-5'>
                        <div className='row align-items-center'>
                            <div className='col-auto'>
                                <p className='person-subtitle mb-0'>{psqiVal.date}</p>
                            </div>
                            <div className='col'>
                                <p className='person-subtitle mb-0'>Click Here <a target="_blank" className='dliq-btn' href={psqiVal.link}>OPEN </a></p>
                            </div>
                        </div>
                    </div>

                </>
            ))}
        </div>
    );
}

export default Psqi;
